import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { setIsShowLoader } from "../store/reducers/loaderReducer";
import MainService from "../helpers/services/mainService";
import { ApiService } from "../helpers/services/apiSrevice";
import SuperDetka from "./SuperDetka";
import MamaDai from "./MamaDai";
import Page404 from "./Page_404";

const CourseContent = () => {

    const dispatch = useDispatch();
    const { courseId } = useParams();
    const [courseData, setCourseData] = useState(null);
    const [isUnavailable, setIsUnavailable] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        getCourseAdvanced(courseId);
    }, [courseId])

    const getCourseAdvanced = () => {
        if (!courseId) { return false };
        setIsUnavailable(false);
        setCourseData(null);
        dispatch(setIsShowLoader(true));
        MainService.callApi({
            api: ApiService.getCourseAdvanced,
            data: +courseId,
            cb: response => {
                if (response && response.data) {
                    setCourseData(response.data);
                } else {
                    setIsUnavailable(true);
                }
            },
            getFail: error => {
                if (isAuthExpirationError(error)) {
                    navigate("/logout");
                    return;
                }
                setIsUnavailable(true);
            },
            _finally: () => {
                setTimeout(() => {
                    dispatch(setIsShowLoader(false));
                }, 1000);
            }
        });
    }

    const isAuthExpirationError = error => error && Number(error.status) === 401;

    if (isUnavailable) { return <Page404 />; }

    if (!courseData) { return null; }

    return <div>
        {
            courseData.zipFilePath ? <SuperDetka courseData={courseData} /> : <MamaDai courseData={courseData} />
        }
    </div>

}

export default CourseContent
